export default (url, implementationCode) => {
    let scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = implementationCode;
    scriptTag.onreadystatechange = implementationCode;

    let body = document.body || document.documentElement

    body.appendChild(scriptTag)
}


// WEBPACK FOOTER //
// ./src/SPRINTA/helpers/LoadScript.js